import "./LuggageSummaryAddButton.scss";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { MoreIcon } from "app/icons/navigation";

const LuggageSummaryAddButton = ({ onLuggageClick = () => {} }) => {
	return (
		<>
			{": "}
			<Button
				variant={BUTTON_VARIANTS.BORDERLESS}
				size={BUTTON_SIZES.SMALL}
				icon={<MoreIcon width={12} height={12} />}
				label={
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
						<FormattedMessage id="quotation.luggage.bookable.label" />
					</Typography>
				}
				onClick={onLuggageClick}
				className="luggage-summary-add-button"
				data-testid="luggage-summary-add"
			/>
		</>
	);
};

LuggageSummaryAddButton.propTypes = {
	onLuggageClick: PropTypes.func,
};

export default LuggageSummaryAddButton;
